import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";

import {
  IHrQuantDistributionHistoryPaginatedResponse,
  getHrQuantDistributionHistoryPaginated,
} from "api";
import { Nullable } from "config";
import { store } from "store";

import { HrQuantDistributionModalMode } from "./enums";
import { IHrQuantDistributionModalData } from "./types";

const initialState = {
  hrQuantDistributionData: null as Nullable<
    IHrQuantDistributionHistoryPaginatedResponse["edges"]
  >,
  totalCount: 1,
  loading: false,
  requestId: undefined as string | undefined,
  modalData: {
    mode: HrQuantDistributionModalMode.VIEW,
    open: false,
    loading: false,
  } as IHrQuantDistributionModalData,
};

export const fetchHrQuantDistributionList = createAsyncThunk(
  "hr/fetchHrQuantDistributionList",
  async () => {
    const filters = store.getState().FiltersReducer;
    if (!Object.values(filters).length) {
      return;
    }
    const response = await getHrQuantDistributionHistoryPaginated(filters);
    return response;
  }
);

const hrQuantDistributionSlice = createSlice({
  name: "hrQuantDistribution",
  initialState,
  reducers: {
    setHrQuantDistributionModalData: (
      state,
      action: PayloadAction<IHrQuantDistributionModalData>
    ) => {
      state.modalData = action.payload;
    },
    closeHrQuantDistributionModal: (state) => {
      state.modalData = initialState.modalData;
    },
    setHrQuantDistributionModalLoading: (
      state,
      action: PayloadAction<boolean>
    ) => {
      state.modalData.loading = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchHrQuantDistributionList.fulfilled, (state, action) => {
      if (state.requestId !== action.meta.requestId) return;
      state.requestId = undefined;
      state.loading = false;
      state.hrQuantDistributionData = action.payload?.edges ?? [];
      state.totalCount = action.payload?.totalCount ?? 0;
    });
    builder.addCase(fetchHrQuantDistributionList.rejected, (state, action) => {
      if (state.requestId !== action.meta.requestId) return;
      state.requestId = undefined;
      state.loading = false;
      state.hrQuantDistributionData = [];
      state.totalCount = 0;
    });
    builder.addCase(fetchHrQuantDistributionList.pending, (state, action) => {
      state.loading = true;
      state.requestId = action.meta.requestId;
    });
  },
});

export const {
  setHrQuantDistributionModalData,
  closeHrQuantDistributionModal,
  setHrQuantDistributionModalLoading,
} = hrQuantDistributionSlice.actions;

export default hrQuantDistributionSlice.reducer;
